import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IProgressChart } from './Dashboard.type';

export interface IDashboard {
  isReloadMiniDashBoard: boolean;
  isReloadAdminDashBoard?: boolean;
}

const initialState: IDashboard = {
  isReloadMiniDashBoard: false,
  isReloadAdminDashBoard: false,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    triggerReloadMiniDashBoard: state => {
      state.isReloadMiniDashBoard = !state.isReloadMiniDashBoard;
    },
    triggerReloadAdminDashBoard: state => {
      state.isReloadAdminDashBoard = !state.isReloadAdminDashBoard;
    },
  },
  extraReducers: builder => {},
});

export const { triggerReloadMiniDashBoard, triggerReloadAdminDashBoard } = dashboardSlice.actions;

export default dashboardSlice.reducer;
